// Textual proficiency levels aligned with backend API
// Keep export names stable for consumers (Levels, LevelCode, isLevel)
export const Levels = [
  "BEGINNER",
  "ELEMENTARY",
  "INTERMEDIATE",
  "UPPER_INTERMEDIATE",
  "ADVANCED",
  "PROFICIENT",
] as const;

export type LevelCode = (typeof Levels)[number];

export function isLevel(code: string | undefined | null): code is LevelCode {
  return !!code && (Levels as readonly string[]).includes(code);
}

/**
 * Get standardized color for a difficulty level
 * Used across all applications for consistent level color scheme
 */
export function getLevelColor(difficulty: LevelCode): string {
  switch (difficulty) {
    case "BEGINNER":
    case "ELEMENTARY":
      return "#4CAF50"; // Green
    case "INTERMEDIATE":
    case "UPPER_INTERMEDIATE":
      return "#FF9800"; // Orange
    case "ADVANCED":
    case "PROFICIENT":
      return "#F44336"; // Red
    default:
      return "#757575"; // Gray fallback
  }
}
